import React from 'react';
import { Section } from '../ui/Section';
export function Hero() {
  return <div className="relative bg-[#FAFAF9] pt-28 pb-16 md:pt-36 md:pb-24 overflow-hidden" data-id="element-74">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#D4AF37]/5 skew-x-12 transform origin-top-right" data-id="element-75" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-76">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-77">
          {/* Text Content - No animations for faster initial render */}
          <div className="text-center lg:text-left" data-id="element-78">
            <span className="inline-block px-3 py-1 bg-[#D4AF37]/10 text-[#D4AF37] text-sm font-semibold tracking-wider uppercase mb-6 rounded-sm" data-id="element-79">
              Para la mujer latina ambiciosa
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-80">
              No es que quieras demasiado. <br data-id="element-81" />
              <span className="text-[#D4AF37] italic" data-id="element-82">
                Es que te enseñaron a pedir poco.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-83">
              Si eres una mujer latina entre 25 y 45 años… trabajadora,
              responsable, ambiciosa (aunque a veces no lo digas en voz alta)… y
              aun así sientes que algo dentro de ti te frena cuando se trata de
              dinero, sigue leyendo.
            </p>

            <p className="mt-6 text-lg md:text-xl text-gray-500 italic" data-id="element-84">
              Porque esto no es casualidad. Y no es un defecto tuyo.
            </p>
          </div>

          {/* Image */}
          <div className="relative" data-id="element-85">
            <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-86">
              {/* Decorative circle */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-white rounded-full opacity-50 blur-3xl" data-id="element-87" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}